import { useRef, useState } from "react";
import { useEngagementTracking } from "./useEngagementTracking";
import { PRODUCT_GROUP } from "@/constants/productKey";
import useIntersectionObserver from "goi_common/src/hooks/useIntersectionObserver";
interface props {
  verificationHref?: string;
}
const useLandingPageScroll = ({
  verificationHref = `/registration/verification/?productGroup=${PRODUCT_GROUP["100"]}`,
}: props) => {
  const [isHeroSectionVisible, setIsHeroSectionVisible] = useState(true);
  const heroSectionScrollTriggerRef = useRef<HTMLDivElement>(null);

  // 사용자 참여도 추적
  const { getHrefByEngagement } = useEngagementTracking({
    lowScrollThreshold: 25,
    highScrollThreshold: 50,
    // lowTimeThreshold: 5,
    // highTimeThreshold: 20,
    baseHref: "/registration/info/",
    trustPageHref: "/registration/info",
    verificationHref,
  });

  useIntersectionObserver({
    root: null,
    target: heroSectionScrollTriggerRef,
    onIntersect: () => {
      setIsHeroSectionVisible(false);
    },
    onNotIntersect: () => {},
    threshold: 0.1,
  });

  const hrefVariation = getHrefByEngagement();
  return {
    isHeroSectionVisible,
    hrefVariation,
    heroSectionScrollTriggerRef,
  };
};

export default useLandingPageScroll;
